module.exports = __webpack_public_path__ + "img/hu.b95aa09e.svg";